
/* styles */
require("!!../../../../../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"sourceMap\":true}!../../../../../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-04637f08&scoped=true!stylus-loader?{\"sourceMap\":true}!../../../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./adminViewAnalyticsGeneralInfo.vue")

var Component = require("!../../../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./adminViewAnalyticsGeneralInfo.vue"),
  /* template */
  require("!!../../../../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-04637f08!../../../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./adminViewAnalyticsGeneralInfo.vue"),
  /* scopeId */
  "data-v-04637f08",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/app/features/admin/adminPortal/adminPortalParlay/adminPortalParlayAnalytics/adminViewAnalyticsGeneralInfo.vue
// module id = 2203
// module chunks = 61